export const isDecimal = (value: number) =>
  String(value)?.split('.')?.length > 1;
